import React, { useEffect, useState } from "react";

import CustomizableTable from "../Tables/CustomizableTable";
import InteractiveTableCell from "../Tables/InteractiveTableCell";

import { connect } from "react-redux";
import {
	showLexWorkplaceMatterSelectorDialog,
	listSmartFileAssociations,
	deleteSmartFileAssociations,
	showDeleteAllSmartFileAssociationsConfirmDialog,
} from "../../actions/smartEmailFilingActions";

import { DropDownButtonWithRouter } from "../DropDownButton";
import { LexWorkplaceGavelIcon } from "../LexWorkplaceIcons";
import { IconUser } from "@tabler/icons-react";
import {
	ARCHIVE_LIFECYCLE_STATUS,
	TRASH_LIFECYCLE_STATUS,
} from "../../utilities/lifecycleStatus";

const EditSmartFileAssociations = (props) => {
	const [smartFileAssociations, setSmartFileAssociations] = useState([]);
	const [loading, setLoading] = useState(true);

	function loadAll() {
		setLoading(true);
		return listSmartFileAssociations().then((res) => {
			setLoading(false);
			setSmartFileAssociations(res.mysql);
		});
	}

	useEffect(() => {
		loadAll();
	}, []);

	const columnConfig = [
		{ Header: "Sender", accessor: "emailAddress", unhidable: true },
		{
			Header: "Matter",
			accessor: "matterName",
			unhidable: true,
			Cell: (row) => (
				<InteractiveTableCell
					menuItems={[
						{
							text: "Change Matter Associated with this Email",
							onSelect: () => {
								const {
									matterID,
									matterName,
									matterLifecycleStatus,
									userHasAccessToMatter,
								} = row.original;

								const smartFileAssociatedMatter = {
									matterID,
									matterName,
									matterLifecycleStatus,
									userHasAccessToMatter,
								};

								const emailAddress = row.original.emailAddress;
								props.showLexWorkplaceMatterSelectorDialog({
									smartFileAssociatedMatter,
									emailAddress,
									postSubmit: () => {
										loadAll();
									},
								});
							},
						},
						{
							text: "Delete this Email/Matter Association",
							onSelect: () => {
								deleteSmartFileAssociations({
									emailAddresses: [row.original.emailAddress],
								}).then(() => {
									loadAll();
								});
							},
						},
					]}
				>
					<span>
						<span>{row.original.matterName}</span>
						{row.original.matterLifecycleStatus ===
						TRASH_LIFECYCLE_STATUS ? (
							<span
								className="tagPill"
								style={{
									backgroundColor: "var(--lw-dark-grey)",
								}}
								title="This Matter is in the trash.  Emails cannot be filed to this Matter."
							>
								Matter in Trash
							</span>
						) : row.original.matterLifecycleStatus ===
						  ARCHIVE_LIFECYCLE_STATUS ? (
							<span
								className="tagPill"
								style={{
									backgroundColor: "var(--lw-dark-grey)",
								}}
								title="This Matter is in the archive.  Emails cannot be filed to this Matter."
							>
								Matter in Archive
							</span>
						) : null}
						{row.original.userHasAccessToMatter ? null : (
							<span
								className="tagPill"
								style={{
									color: "black",
									backgroundColor: "var(--lw-gold)",
								}}
								title="You do not have sufficient permissions to file emails to this Matter."
							>
								No Permissions
							</span>
						)}
					</span>
				</InteractiveTableCell>
			),
		},
		{ Header: "Client", accessor: "clientName" },
	];

	return (
		<div className="fullHeightFlex noDefaultMargin">
			<CustomizableTable
				className="fullWidth"
				loading={loading}
				actionButtons={({ openCsvExport }) => (
					<div
						style={{
							display: "flex",
							gap: 8,
						}}
					>
						<DropDownButtonWithRouter
							title="Actions"
							iconComponent={<LexWorkplaceGavelIcon />}
							pullRight
							menuItems={[
								{
									text: "Delete All Associations",
									onSelect: () => {
										props.showDeleteAllSmartFileAssociationsConfirmDialog(
											{
												postSubmit: () => {
													loadAll();
												},
											}
										);
									},
								},
								{
									text: "Export Data as CSV",
									onSelect: openCsvExport,
								},
							]}
						/>
					</div>
				)}
				leftSideIconComponent={
					<IconUser
						size={24}
						style={{ alignSelf: "center", margin: "0 8px" }}
					/>
				}
				data={smartFileAssociations}
				autoResize
				columns={columnConfig}
				noResultsText={"No items here"}
				tableUniqueID="/settings/manageSmartFileAssociations"
				csvExport={{
					fileName: "smart-file-associations-export",
				}}
			/>
		</div>
	);
};

const mapStateToProps = () => {
	return {};
};
export default connect(mapStateToProps, {
	showLexWorkplaceMatterSelectorDialog,
	showDeleteAllSmartFileAssociationsConfirmDialog,
})(EditSmartFileAssociations);

//export default EditSmartFileAssociations;
